export default "__VITE_ASSET__97674e51__"